import bridge from '@bridge/imlv';

export default bridge;
